class User {
  constructor() {
    this.token = "";
    this.name = "";
    this.email = "";
    this.locale = "";
    this.system = "";
    this.brandPermissions = {};
    this.permissions = [
      /*{
        "brand": "ulu",
        "customer_create": true,
        "customer_show": true,
        "customers_index": true,
        "inquiries_index": true,
        "inquiry_create": true,
        "inquiry_create_master": true,
        "inquiry_show": true,
        "invoice_paid": true,
        "invoice_pause": true,
        "invoice_resume": true,
        "invoices_index": true,
        "order_create": true,
        "order_show": true,
        "orders_index": true,
        "permissions_edit": true,
        "permissions_show": true,
        "permissions_index": true,
        "price_list_edit": true,
        "price_list_index": true,
        "price_list_show": true
      },
      {
        "brand": "fleetify",
        "customer_create": true,
        "customer_show": true,
        "customers_index": true,
        "inquiries_index": true,
        "inquiry_create": true,
        "inquiry_create_master": true,
        "inquiry_show": true,
        "invoice_paid": true,
        "invoice_pause": true,
        "invoice_resume": true,
        "invoices_index": true,
        "order_create": true,
        "order_show": true,
        "orders_index": true,
        "permissions_edit": true,
        "permissions_show": true,
        "permissions_index": true,
        "price_list_edit": true,
        "price_list_index": true,
        "price_list_show": true
      },
      {
        "brand": "cartracker",
        "customer_create": true,
        "customer_show": true,
        "customers_index": true,
        "inquiries_index": true,
        "inquiry_create": true,
        "inquiry_create_master": true,
        "inquiry_show": true,
        "invoice_paid": true,
        "invoice_pause": true,
        "invoice_resume": true,
        "invoices_index": true,
        "order_create": true,
        "order_show": true,
        "orders_index": true,
        "permissions_edit": true,
        "permissions_show": true,
        "permissions_index": true,
        "price_list_edit": true,
        "price_list_index": true,
        "price_list_show": true
      }*/
    ];
  }
}

export default User;
